<template>
  <b-card class="rounded-xl">
    <div class="h-full">
      <div>
        <h2 class="font-semibold  mb-8 text-2xl">
          Create Campaign
        </h2>
        <div class=" lg:grid md:grid grid-cols-4  gap-8 mobile-campaign ">
          <b-card
            v-for="(item, index) in cards"
            :key="'item-' + index"
            class="p-4 cust-shadow mobile-mb4 mobile-custwidadmin"
            no-body
          >
            <div class="flex justify-center mt-2">
              <img :src="item.img" class=" object-cover w-1/3 rounded-t-lg" />
            </div>
            <div
              class="text-center cursor-pointer  mt-4"
              @click="handleClick(item)"
            >
              <h3 class="font-bold hover:underline  text-md">
                {{ item.text }}
              </h3>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <div>
      <TemplateTable />
    </div>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TemplateTable from "./components/TemplateTable";
export default {
  components: {
    TemplateTable
  },
  data() {
    return {
      cards: [
        {
          img: require("./img/sms.png"),
          text: "SMS",
          route: "template-sms"
        },
        {
          img: require("./img/email.png"),
          text: "E-MAIL",
          route: "template-email"
        },

        {
          img: require("./img/whatsapp.png"),
          text: "WHATSAPP",
          route: "template-whatsapp"
        },
        {
          img: require("./img/notification.png"),
          text: "PUSH NOTIFICATION",
          route: "template-pushnotification"
        }
      ]
    };
  },
  methods: {
    handleClick({ route }) {
      this.$router.push({ name: route });
    }
  }
};
</script>
<style>
.vs-card--content {
  margin-bottom: 0px !important;
}
</style>
